import { render, staticRenderFns } from "./BaseFormInputWithCopy.vue?vue&type=template&id=35dcdeb8&scoped=true"
import script from "./BaseFormInputWithCopy.vue?vue&type=script&lang=js"
export * from "./BaseFormInputWithCopy.vue?vue&type=script&lang=js"
import style0 from "./BaseFormInputWithCopy.vue?vue&type=style&index=0&id=35dcdeb8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcdeb8",
  null
  
)

export default component.exports